import { render, staticRenderFns } from "./RelatorRegistra.vue?vue&type=template&id=733267c0&"
import script from "./RelatorRegistra.vue?vue&type=script&lang=js&"
export * from "./RelatorRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports